<template>
    <div class="mb-4">
        <p class="text-center text-3lg mb-4 text-navy font-bold">Choose your channel package</p>
        <div class="grid grid-cols-1 tablet:grid-cols-2 widescreen:grid-cols-3 gap-4">
            <TVPackagesCards_Card
                title="Locals+"
                :channel-count="channelCounts.localsPlus"
                :price="getServicePrice(mainService)"
                image-alt="Logos of channels included with the Starter plus channel package"
                image="stater-plus-preview.jpeg"
                :isSelected="hasSelectedAService"
                @select="select()"
                @deselect="select(true)"
                @show-channel-lineup="$emit('show-channel-lineup')"
            />

            <TVPackagesCards_Card
                v-if="varietyPlus"
                title="Locals+ & Variety+"
                :channel-count="(channelCounts.localsPlus + channelCounts.varietyPlus)"
                :price="getServicePrice(mainService) + varietyPlus.price"
                image-alt="Logos of channels included with the Variety plus channel package"
                image="variety-plus-preview.jpeg"
                :isSelected="isPackageSelected(varietyPlus)"
                @select="select(false, familyPlus && isPackageSelected(familyPlus)? [varietyPlus, familyPlus]: varietyPlus)"
                @deselect="$emit('select-package', familyPlus && isPackageSelected(familyPlus)? [varietyPlus, familyPlus]: varietyPlus)"
                @show-channel-lineup="$emit('show-channel-lineup')"
            />

            <TVPackagesCards_Card
                v-if="familyPlus"
                title="Locals+, Variety+ & Family+"
                :channel-count="(channelCounts.localsPlus + channelCounts.varietyPlus + channelCounts.familyPlus)"
                :price="getServicePrice(mainService) + varietyPlus.price + familyPlus.price"
                image-alt="Logos of channels included with the Family plus channel package"
                image="family-plus-preview.jpeg"
                :isSelected="isPackageSelected(familyPlus)"
                @select="select(false,  isPackageSelected(varietyPlus)? familyPlus: [varietyPlus, familyPlus])"
                @deselect="$emit('select-package', familyPlus)"
                @show-channel-lineup="$emit('show-channel-lineup')"
            />
        </div>
    </div>
</template>

<script>
    import TVPackagesCards_Card from "./card.vue";
    export default {
        name: 'TVPackagesCards',
        components: {
            TVPackagesCards_Card,
        },
        props: {
            mainService: {
                type: Object,
                required: false,
            },
            localsPlus: {
                type: Object,
                required: true,
            },
            varietyPlus: {
                type: Object,
                required: false,
            },
            familyPlus: {
                type: Object,
                required: false,
            },
            hboMax: {
                type: Object,
                required: false,
            },
            isPackageSelected: {
                type: Function,
                required: true,
            },
            hasSelectedAService: {
                type: Boolean,
                default: false,
            },
            getServicePrice: {
                type: Function,
                default: () => 0,
            },
            localsChannelCount: {
                type: Number,
                default: 0,
            },
            channelCounts: {
                type: Object,
                default: () => ({
                    localsPlus: 40,
                    varietyPlus: 20,
                    familyPlus: 20,
                }),
            },
            isWowMarket: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            hasFamilyPlus() {
                return Boolean(this.familyPlus)
            },
        },
        methods: {
            select(deselect = false, additionalPackages = null){
                if (deselect)  {
                    this.$emit('decline', true)
                } else {
                    if (this.hboMax && this.isPackageSelected(this.hboMax)? this.hboMax: null) {
                        this.$emit('select-package', this.hboMax)
                    }

                    this.selectTVOptions({
                        service: {
                            decision: this.localsPlus.decision,
                            selection: this.localsPlus
                        },
                        equipment: {
                            decision: this.mainService.decision,
                            selection: this.mainService
                        },
                        declined: false
                    })
                    if (additionalPackages) {
                        this.$emit('select-package', additionalPackages)
                    }
                }
            },

            selectTVOptions (options) {
                this.$emit('select-service', options)
            },
        },
    }
</script>
